/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для кнопки паджинации
   */
  app.PaginationButtonView = app.View.extend({
    label: 1,
    page: 1,
    buttonClass: '',
    disabled: false,
    parentView: this,
    template: '',
    router: false,
    
    events: {
      'click': 'choosePage'
    },
    
    run: function (data) {
      for (var i in data) {
        if (data.hasOwnProperty(i)) {
          this[i] = data[i];
        }
      }
      this.template = app.helpers.TemplateHelper.getTemplate('#pagination-button');
    },
    
    render: function () {
      var data = {
        label: this.label,
        page: this.page,
        buttonClass: this.buttonClass,
        disabled: this.disabled
      };
      var el = $(this.template(data));
      this.setElement(el);
      return this;
    },
    /**
     * Обработчик нажатия на кнопку страницы
     */
    choosePage: function () {
      var page = this.$el.data('page'),
        path = '/';
      if (page && page !== this.model.state.currentPage) {
        this.$el.siblings('.b-pagination__page_selected').removeClass('b-pagination__page_selected');
        this.$el.addClass('b-pagination__page_selected');
        if (page !== 1) {
          path = '/p' + page;
        }
        this.router.navigate(path, {trigger: true}, {});
      }
    }
  });
})(jQuery);

}.call(window));